import { Checkbox as AntCheckbox } from 'antd';
import type { CheckboxProps } from 'antd';

/** Hộp kiểm (§9.3.12). Chuyển tiếp thuần. */
export function Checkbox(props: CheckboxProps) {
  return <AntCheckbox {...props} />;
}
